import { useEffect, useState } from 'react';
import { FormattedMessage } from 'react-intl';
import PropTypes from 'prop-types';

import { useLocation } from 'react-router';

const ShowResults = ({ totalElements, size }, ...props) => {
    const location = useLocation();

    const [minElement, setMinElements] = useState(0);
    const [lastElement, setLastElements] = useState(parseInt(totalElements));

    useEffect(() => {
        const params = new URLSearchParams(location.search);
        const result = params.get('page');
        const currentPage = parseInt(result) + 1 || 1;
        const maxElement = currentPage * size;
        const minElement = totalElements > 0 ? ((maxElement - size + 1) < 1 ? 1 : (maxElement - size + 1)) : 0;
        setMinElements(minElement);
        const lastElement = maxElement > totalElements ? totalElements : maxElement;
        setLastElements(lastElement);
    }, [location, totalElements, size]);

    return (
        <span data-testid={props['data-testid']}>
            <FormattedMessage
                id='showResults.showingResults'
                values={{
                    minElement: minElement || 0,
                    lastElement: lastElement || 0,
                    totalElements: totalElements || 0
                }}
            />
        </span>
    );
};

ShowResults.propTypes = {
    totalElements: PropTypes.number.isRequired,
    size: PropTypes.number.isRequired,
    'data-testid': PropTypes.string,
    'aria-label': PropTypes.string,
    'aria-labelledby': PropTypes.string,
    'aria-describedby': PropTypes.string,
    'aria-details': PropTypes.string
};

export default ShowResults;
